import { gql } from "@apollo/client";

export const MY_DASHBOARD_FILTER_QUERY = gql`
    query MyDashboardFilter {
        companies {
            items {
                key
                name
            }
        }
        subBrands {
            items {
                key
                name
            }
        }
        brands {
            items {
                key
                name
            }
        }
        categories {
            items {
                key
                name
            }
        }
        routeToMarkets {
            items {
                key
                name
            }
        }
        channels {
            items {
                key
                name
            }
        }
    }
`;

